export const CALL_REMINDER_IN_MINUTES: string = import.meta.env.VITE_REMINDER_IN_MINUTES as string
